import React, { useState, useMemo } from "react";
import { Text, Dropdown, Icon } from "components/commons";
import { useMount } from "hooks";
import lang from "translations";
import { redirectTo } from "services";
import classnames from "classnames";
const LangSelector = () => {
  const { _language } = lang;
  const [active, setActive] = useState(_language);

  const languagePack = [
    {
      text: "EN - English",
      key: "en",
    },
    {
      text: "ES - Spanish",
      key: "es",
    },
    {
      text: "PT - Portuguese",
      key: "pt",
    },
    {
      text: "TH - Thai",
      key: "th",
    },
  ];

  useMount(() => {
    localStorage.setItem("locale", _language);
  });

  const languageOptions = useMemo(() => {
    return languagePack.map((language) => {
      return {
        ...language,
        text: (
          <Text
            size="text-sm"
            className={classnames(
              "hover:text-pelorous",
              "leading-6",
              "w-28",
              active === language.key ? "text-pelorous" : "text-gray"
            )}
          >
            {language.text}
          </Text>
        ),
        value: language.text,
        onClick: () => {

          setActive(language.key);
          const query = new URLSearchParams(window.location.search);
          query.delete("lang");
          const currentPath = window.location.pathname;
          localStorage.setItem("locale", language.key);
          redirectTo(`${currentPath}${query.toString() === "" ? "" : `?${query.toString()}`} `);
        },
      };
    });
    // eslint-disable-next-line
  }, [active]);

  return (
    <Dropdown
      trigger="click"
      placement="bottomCenter"
      className="cursor-pointer text-xs"
      options={languageOptions}
    >
      <div className="flex items-center justify-center">
        <Icon
          name="globe"
          className="text-md text-gray-dark hover:text-pelorous active:bg-pelorous focus:bg-pelorous mb-0.5"
        />
      </div>
    </Dropdown>
  );
};

export default LangSelector;
